class DetailsModal extends HTMLElement {
  constructor() {
    super();
    this.detailsContainer = this.querySelector('details');
    this.summaryToggle = this.querySelector('summary');

    this.detailsContainer.addEventListener('keyup', (event) => event.code.toUpperCase() === 'ESCAPE' && this.close());
    this.summaryToggle.addEventListener('click', this.onSummaryClick.bind(this));
    this.querySelector('button[type="button"]').addEventListener('click', this.close.bind(this));

    this.summaryToggle.setAttribute('role', 'button');
  }

  isOpen() {
    return this.detailsContainer.hasAttribute('open');
  }

  onSummaryClick(event) {
    event.preventDefault();
    event.target.closest('details').hasAttribute('open') ? this.close() : this.open(event);
  }

  onBodyClick(event) {
    if (!this.contains(event.target) || event.target.classList.contains('modal-overlay')) this.close(false);
  }

  open(event) {
    this.onBodyClickEvent = this.onBodyClickEvent || this.onBodyClick.bind(this);
    event.target.closest('details').setAttribute('open', true);
    document.body.addEventListener('click', this.onBodyClickEvent);
    document.body.classList.add('overflow-hidden');

    trapFocus(
      this.detailsContainer.querySelector('[tabindex="-1"]'),
      this.detailsContainer.querySelector('input:not([type="hidden"])')
    );
  }

  close(focusToggle = true) {
    removeTrapFocus(focusToggle ? this.summaryToggle : null);
    this.detailsContainer.removeAttribute('open');
    document.body.removeEventListener('click', this.onBodyClickEvent);
    document.body.classList.remove('overflow-hidden');
  }
}

customElements.define('details-modal', DetailsModal);


// code changes v5.4 function added
document.addEventListener('DOMContentLoaded', function () {
  // Get all open buttons by class
  const openButtons = document.querySelectorAll('.ProductPopup-product_details');

  // Function to open the modal
  function openModal(modalId) {
    const modal = document.getElementById(modalId);
    if (modal) {
      //console.log("Opening modal:", modalId); // Log modal ID being opened
      modal.classList.remove('modal-hidden'); // Show the modal
      document.body.classList.add('overflow-hidden'); // Disable scrolling
    } else {
      //console.error("Modal not found:", modalId); // Log if modal is not found
    }
  }

  // Function to close the modal
  function closeModal(modalId) {
    const modal = document.getElementById(modalId);
    if (modal) {
      //console.log("Closing modal:", modalId); // Log modal ID being closed
      modal.classList.add('modal-hidden'); // Hide the modal
      document.body.classList.remove('overflow-hidden'); // Enable scrolling
    }
  }

  // Loop through all open buttons and add event listeners
  openButtons.forEach(button => {
    button.addEventListener('click', function () {
      const modalTarget = button.getAttribute('data-modal-target'); // Get the data-modal-target attribute
      
      if (modalTarget) { // Check if modalTarget is not null
        const modalId = modalTarget//.substring(1); // Remove '#' from the ID
        //console.log("Modal Target:", modalTarget, "Modal ID:", modalId); // Log target and ID
        openModal(modalId);
      } else {
        //console.error('data-modal-target attribute is missing on the button:', button);
      }
    });
  });

  // Get all close buttons by class
  const closeButtons = document.querySelectorAll('.ModalClose-product');

  // Loop through all close buttons and add event listeners
  closeButtons.forEach(button => {
    button.addEventListener('click', function () {
      const modalTarget = button.getAttribute('data-modal-target'); // Get target modal ID from data attribute
      
      if (modalTarget) {
        const modalId = modalTarget//.substring(1); // Remove '#' from the ID
        closeModal(modalId);
      } else {
        //console.error('data-modal-target attribute is missing on the close button:', button);
      }
    });
  });
});

document.addEventListener('click', function(e) {
   const badge = e.target.closest('.jdgm-widget-popup-details');
   if (badge) {
       // Stop the default scroll behavior
       e.preventDefault();
       e.stopPropagation();
       
       // Find the modal and the reviews section by ID
       const modal = badge.closest('.product-popup-modal__content');
       const reviewsSection = modal.querySelector('#product_reviews');
       
       if (modal && reviewsSection) {
           setTimeout(() => {
               reviewsSection.scrollIntoView({ behavior: 'smooth' });
           }, 100);
       }
       
       return false;
   }
}, true);
